import React from 'react';

const EmptyData: React.FC = () => {
    return <div className="dr-empty-data">Für diesen Bericht sind keine anzuzeigenden Daten vorhanden.</div>;
};

export default EmptyData;
